import { Suspense, useContext } from "react";
import { useProductTranslations } from "../../hooks/TranslationHooks";
import CartItem from "../CartItem";
import classNames from "classnames";
import CartTotal from "../CartTotal";
import { sortByIsSample } from "../../utils/CartUtils";
import { Spinner } from "reactstrap";
import "./style.scss";
import { CartContext } from "../../functional-components/CartContext";

const Cart = ({ id, style, className, isCompact = false }) => {
  const tp = useProductTranslations();
  const { getItems } = useContext(CartContext);
  const items = getItems();

  return (
    <Suspense
      fallback={
        <div
          style={{
            height: "8rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Spinner />
        </div>
      }
    >
      {items.length > 0 ? (
        <ul
          id={id}
          className={classNames(
            "cart-items",
            { compact: isCompact },
            className
          )}
          style={style}
        >
          {items
            .map((item, idx) => {
              item.index = idx;
              return item;
            })
            .sort(sortByIsSample)
            .map((item, idx) => (
              <CartItem
                key={idx}
                item={item}
                index={item.index}
                compact={isCompact}
              />
            ))}
        </ul>
      ) : (
        <h4 className={"text-center mb-5"}>{tp("cart.is.empty")}</h4>
      )}
      {items.length > 0 && !isCompact && <CartTotal className={"mt-3"} />}
    </Suspense>
  );
};

export default Cart;
